module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-close-icon-3-83c6417b8df1bd45dc98e3bc1e687a73.svg";